document.addEventListener("DOMContentLoaded", function () {

  /* =========================================================
     AUDIO PLAYER
  ========================================================= */

  const audio = document.getElementById("audioPlayer");
  const volume = document.getElementById("volume");
  const volVal = document.getElementById("volVal");

  function updateVolume() {
    if (!audio || !volume) return;

    const percent = volume.value * 100;

    audio.volume = volume.value;

    if (volVal) {
      volVal.textContent = Math.round(percent) + "%";
    }

    volume.style.background = `linear-gradient(
      to right,
      #EACB74 ${percent}%,
      rgba(255,255,255,.4) ${percent}%
    )`;
  }

  if (volume) {
    volume.addEventListener("input", updateVolume);
    updateVolume();
  }


  /* =========================================================
     AUDIO LIBRARY
  ========================================================= */

  const cards = document.querySelectorAll(".hm_audio_card");
  const categorySections = document.querySelectorAll(
    ".hm_audio_itms [data-category]"
  );
  const buttons = document.querySelectorAll(".hm_audio_lbry_btn");

  const playerImage = document.getElementById("playerImage");
  const playerTitle = document.getElementById("playerTitle");
  const playerSubtitle = document.getElementById("playerSubtitle");
  const playerDesc = document.getElementById("playerDesc");
  const playPauseBtn = document.getElementById("playPauseBtn");
  const playPauseIcon = document.getElementById("playPauseIcon");
  const nowPlayingBox = document.querySelector(".now-playing");

  const progressBar = document.getElementById("progressBar");
  const progressThumb = document.getElementById("progressThumb");
  const currentTimeEl = document.getElementById("currentTime");
  const totalTimeEl = document.getElementById("totalTime");

  let currentCard = null;


  function showPlayIcon() {
    if (!playPauseIcon) return;

    const url =
      "https://cdn.shopify.com/s/files/1/0781/2451/5587/files/playPause.svg?v=1767778666";

    playPauseIcon.style.maskImage = `url('${url}')`;
    playPauseIcon.style.webkitMaskImage = `url('${url}')`;
  }


  function showPauseIcon() {
    if (!playPauseIcon) return;

    const url =
      "https://cdn.shopify.com/s/files/1/0781/2451/5587/files/pause.svg?v=1767785495";

    playPauseIcon.style.maskImage = `url('${url}')`;
    playPauseIcon.style.webkitMaskImage = `url('${url}')`;
  }


  function loadDefaultAudio() {
    if (!audio || !cards.length) return;

    const firstCard = cards[0];

    const src = firstCard.dataset.audio;
    const title = firstCard.dataset.title;
    const img = firstCard.querySelector("img")?.src;
    const subtitle =
      firstCard.querySelector(".hm_audio_card_bdy p")?.textContent || "";
    const desc =
      firstCard.querySelector(".hm_audio_card_bdy span")?.textContent || "";

    audio.src = src || "";

    if (playerImage && img) {
      playerImage.style.backgroundImage = `url(${img})`;
      playerImage.classList.add("has-image");
    }

    if (playerTitle) {
      playerTitle.textContent = title || "Audio Title";
    }

    if (playerSubtitle) {
      playerSubtitle.textContent = subtitle;
    }

    if (playerDesc) {
      playerDesc.textContent = desc;
    }

    showPlayIcon();

    currentCard = firstCard;
  }


  cards.forEach((card) => {

    card.addEventListener("click", () => {

      if (!audio) return;

      const src = card.dataset.audio;
      const title = card.dataset.title;
      const img = card.querySelector("img")?.src;
      const subtitle =
        card.querySelector(".hm_audio_card_bdy p")?.textContent || "";
      const desc =
        card.querySelector(".hm_audio_card_bdy span")?.textContent || "";


      /* SAME CARD */

      if (currentCard === card) {

        if (audio.paused) {

          audio.play().catch(() => {});

          showPauseIcon();

          nowPlayingBox?.classList.add("playing");
          card.classList.add("playing");

        } else {

          audio.pause();

          showPlayIcon();

          nowPlayingBox?.classList.remove("playing");
          card.classList.remove("playing");
        }

        return;
      }


      /* NEW CARD */

      cards.forEach((c) => {
        c.classList.remove("playing");
      });

      audio.src = src || "";

      audio.play().catch(() => {});

      if (playerImage && img) {
        playerImage.style.backgroundImage = `url(${img})`;
        playerImage.classList.add("has-image");
      }

      if (playerTitle) {
        playerTitle.textContent = title || "";
      }

      if (playerSubtitle) {
        playerSubtitle.textContent = subtitle;
      }

      if (playerDesc) {
        playerDesc.textContent = desc;
      }

      showPauseIcon();

      card.classList.add("playing");
      nowPlayingBox?.classList.add("playing");

      currentCard = card;
    });

  });


  /* PLAY / PAUSE */

  playPauseBtn?.addEventListener("click", () => {

    if (!audio || !audio.src) return;

    if (audio.paused) {

      audio.play().catch(() => {});

      showPauseIcon();

      nowPlayingBox?.classList.add("playing");
      currentCard?.classList.add("playing");

    } else {

      audio.pause();

      showPlayIcon();

      nowPlayingBox?.classList.remove("playing");
      currentCard?.classList.remove("playing");
    }

  });


  /* +/- 10 SEC */

  document.getElementById("nextBtn")?.addEventListener("click", () => {

    if (!audio?.duration) return;

    audio.currentTime = Math.min(
      audio.currentTime + 10,
      audio.duration
    );

  });


  document.getElementById("prevBtn")?.addEventListener("click", () => {

    if (!audio?.duration) return;

    audio.currentTime = Math.max(
      audio.currentTime - 10,
      0
    );

  });


  /* PROGRESS BAR */

  const progressContainer = document.querySelector(".progress");
  let isDragging = false;


  function updateSeek(clientX) {

    if (!audio?.duration || !progressContainer) return;

    const rect = progressContainer.getBoundingClientRect();

    const x = clientX - rect.left;

    const percent = Math.min(
      Math.max(x / rect.width, 0),
      1
    );

    audio.currentTime = percent * audio.duration;
  }


  progressContainer?.addEventListener("click", (e) => {

    if (!audio?.duration) return;

    updateSeek(e.clientX);

  });


  progressContainer?.addEventListener("mousedown", (e) => {

    isDragging = true;

    updateSeek(e.clientX);

  });


  document.addEventListener("mousemove", (e) => {

    if (!isDragging || !audio?.duration) return;

    updateSeek(e.clientX);

  });


  document.addEventListener("mouseup", () => {

    isDragging = false;

  });


  progressContainer?.addEventListener(
    "touchstart",
    (e) => {

      isDragging = true;

      updateSeek(e.touches[0].clientX);

    },
    { passive: true }
  );


  progressContainer?.addEventListener(
    "touchmove",
    (e) => {

      if (!isDragging || !audio?.duration) return;

      updateSeek(e.touches[0].clientX);

    },
    { passive: true }
  );


  progressContainer?.addEventListener("touchend", () => {

    isDragging = false;

  });


  /* AUDIO TIME UPDATE */

  audio?.addEventListener("timeupdate", () => {

    if (!audio.duration) return;

    const percent =
      (audio.currentTime / audio.duration) * 100;

    if (progressBar) {
      progressBar.style.width = percent + "%";
    }

    if (progressThumb) {
      progressThumb.style.left = percent + "%";
    }

    if (currentTimeEl) {

      currentTimeEl.textContent =
        Math.floor(audio.currentTime / 60) +
        ":" +
        Math.floor(audio.currentTime % 60)
          .toString()
          .padStart(2, "0");

    }

    if (totalTimeEl) {

      totalTimeEl.textContent =
        Math.floor(audio.duration / 60) +
        ":" +
        Math.floor(audio.duration % 60)
          .toString()
          .padStart(2, "0");

    }

  });


  audio?.addEventListener("ended", () => {

    showPlayIcon();

    nowPlayingBox?.classList.remove("playing");

    currentCard?.classList.remove("playing");

  });


  loadDefaultAudio();


  /* =========================================================
     AUDIO CATEGORY
  ========================================================= */

  categorySections.forEach((section) => {

    section.style.display =
      section.dataset.category === "Chakra"
        ? ""
        : "none";

  });


  buttons.forEach((btn) => {

    btn.addEventListener("click", () => {

      buttons.forEach((b) => {
        b.classList.remove("active");
      });

      btn.classList.add("active");

      const filter = btn.dataset.filter;

      categorySections.forEach((section) => {

        section.style.display =
          section.dataset.category === filter
            ? ""
            : "none";

      });

    });

  });


  /* =========================================================
     RASHI TABS
  ========================================================= */

  const rashiTabs = document.querySelectorAll(
    ".rashi_cmbo_list_lft-wrapper a"
  );

  const rashiContents = document.querySelectorAll(
    ".rashi_cmbo_list_rght li"
  );


  rashiTabs.forEach((tab) => {

    tab.addEventListener("click", (e) => {

      e.preventDefault();

      const target = tab.getAttribute("href");

      rashiTabs.forEach((t) => {
        t.classList.remove("active");
      });

      rashiContents.forEach((c) => {
        c.classList.remove("active");
      });

      tab.classList.add("active");

      document.querySelector(target)?.classList.add("active");

    });

  });


  /* =========================================================
     SPECIAL TABS
  ========================================================= */

  document.querySelectorAll(".sptl_tab li").forEach((tab) => {

    tab.addEventListener("click", () => {

      const id = tab.dataset.tab;

      document
        .querySelectorAll(".sptl_tab li, .tab_cnt")
        .forEach((el) => {
          el.classList.remove("current");
        });

      tab.classList.add("current");

      document
        .getElementById(id)
        ?.classList.add("current");

    });

  });


  /* =========================================================
     LIKE HEART
  ========================================================= */

  document.querySelectorAll(".likeHeart").forEach((heart) => {

    heart.addEventListener("click", () => {

      heart.classList.toggle("active");

    });

  });


  /* =========================================================
     FAQ
  ========================================================= */

  document.querySelectorAll(".hm_faq_hrd").forEach((header) => {

    header.addEventListener("click", () => {

      const body = header.nextElementSibling;

      if (!body) return;


      if (header.classList.contains("active")) {

        header.classList.remove("active");

        body.style.display = "none";

      } else {

        document
          .querySelectorAll(".hm_faq_hrd")
          .forEach((h) => {
            h.classList.remove("active");
          });

        document
          .querySelectorAll(".hm_faq_bdy")
          .forEach((b) => {
            b.style.display = "none";
          });

        header.classList.add("active");

        body.style.display = "block";

      }

    });

  });


  /* =========================================================
     QUICK ADD / WISHLIST
  ========================================================= */

  document
    .querySelectorAll(".quick-add-btn")
    .forEach((btn) => {

      const productId =
        btn.getAttribute("data-product-id");

      const icon =
        btn.querySelector(".cart-icon");

      const success =
        btn.querySelector(".cart-success");


      if (!productId) return;


      if (
        localStorage.getItem(
          "wishlist-" + productId
        )
      ) {

        btn.classList.add("active");

        if (icon) {
          icon.style.display = "none";
        }

        if (success) {
          success.hidden = false;
        }

      }


      btn.addEventListener("click", () => {

        if (btn.classList.contains("active")) {

          btn.classList.remove("active");

          localStorage.removeItem(
            "wishlist-" + productId
          );

          if (success) {
            success.hidden = true;
          }

          if (icon) {
            icon.style.display = "block";
          }

        } else {

          btn.classList.add("active");

          localStorage.setItem(
            "wishlist-" + productId,
            "true"
          );

          if (icon) {
            icon.style.display = "none";
          }

          if (success) {
            success.hidden = false;
          }

        }

      });

    });


  /* =========================================================
     COLLECTION HOVER
  ========================================================= */

  const collectionItems =
    document.querySelectorAll(
      ".pandit_hm_cltn li"
    );


  collectionItems.forEach((item) => {

    item.addEventListener("mouseenter", () => {

      collectionItems.forEach((i) => {
        i.classList.remove("active");
      });

      item.classList.add("active");

    });

  });


  /* =========================================================
     PRODUCT WISHLIST
  ========================================================= */

  document.addEventListener("click", (e) => {

    const heart =
      e.target.closest(".hrt_svg");

    if (!heart) return;

    const productId =
      heart.dataset.productId;

    if (!productId) return;

    let wishlist =
      JSON.parse(
        localStorage.getItem("wishlist")
      ) || [];


    if (wishlist.includes(productId)) {

      wishlist =
        wishlist.filter(
          (id) => id !== productId
        );

      heart.classList.remove("active");

    } else {

      wishlist.push(productId);

      heart.classList.add("active");

    }


    localStorage.setItem(
      "wishlist",
      JSON.stringify(wishlist)
    );

  });


  /* =========================================================
     HERO SWIPER
  ========================================================= */

  function initHeroSwiper() {
    if (typeof Swiper === "undefined") return;
    const slider = document.querySelector(".heroSwiper");
    if (!slider) return;
    if (slider.classList.contains("swiper-initialized")) return;
    new Swiper(slider, {
      loop: true,
      speed: 800,
      slidesPerView: 1,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      observer: true,
      observeParents: true
    });
  }


  /* =========================================================
     PRODUCT SWIPER - LAZY INITIALIZATION
  ========================================================= */

  const productSliders =
    document.querySelectorAll(
      ".pt-productSwiper"
    );


  const initializedSliders =
    new WeakSet();


  function initProductSwiper(slider) {

    if (
      typeof Swiper === "undefined" ||
      !slider ||
      initializedSliders.has(slider)
    ) {
      return;
    }


    if (
      slider.classList.contains(
        "swiper-initialized"
      )
    ) {
      initializedSliders.add(slider);
      return;
    }


    const next =
      slider.querySelector(
        ".swiper-button-next"
      );

    const prev =
      slider.querySelector(
        ".swiper-button-prev"
      );


    new Swiper(slider, {

      slidesPerView: 4,

      spaceBetween: 1,

      loop: false,

      speed: 700,

      navigation: {
        nextEl: next,
        prevEl: prev
      },

      breakpoints: {

        1024: {
          slidesPerView: 4
        },

        768: {
          slidesPerView: 2
        },

        0: {
          slidesPerView: 2
        }

      }

    });


    initializedSliders.add(slider);

  }


  /* Initialize only visible/near-visible sliders */

  if ("IntersectionObserver" in window) {

    const sliderObserver =
      new IntersectionObserver(
        (entries) => {

          entries.forEach((entry) => {

            if (!entry.isIntersecting) return;

            initProductSwiper(entry.target);

            sliderObserver.unobserve(
              entry.target
            );

          });

        },
        {
          rootMargin: "200px",
          threshold: 0.1
        }
      );


    productSliders.forEach((slider) => {

      sliderObserver.observe(slider);

    });

  } else {

    productSliders.forEach((slider) => {

      initProductSwiper(slider);

    });

  }


  /* =========================================================
     ZODIAC TABS
  ========================================================= */

  const zodiacItems =
    document.querySelectorAll(
      ".pt-zodiac-item"
    );


  function activateZodiac(element) {

    if (!element) return;


    zodiacItems.forEach((el) => {

      el.classList.remove("active");

    });


    element.classList.add("active");


    document
      .querySelectorAll(".pt-product-tab")
      .forEach((tab) => {

        tab.classList.remove("active");

      });


    const zodiac =
      element.getAttribute(
        "data-zodiac"
      );


    const targetTab =
      document.getElementById(zodiac);


    if (!targetTab) return;


    targetTab.classList.add("active");


    /* Initialize only selected zodiac slider */

    const slider =
      targetTab.querySelector(
        ".pt-productSwiper"
      );


    if (slider) {

      initProductSwiper(slider);

    }

  }


  zodiacItems.forEach((item) => {

    item.addEventListener("click", () => {

      activateZodiac(item);

    });

  });


  /* Initialize first zodiac */

  const firstZodiac =
    document.querySelector(
      ".pt-zodiac-item.active"
    );


  if (firstZodiac) {

    const firstTarget =
      document.getElementById(
        firstZodiac.dataset.zodiac
      );


    if (firstTarget) {

      initProductSwiper(
        firstTarget.querySelector(
          ".pt-productSwiper"
        )
      );

    }

  }


  /* =========================================================
     HERO INIT
  ========================================================= */

  initHeroSwiper();


  /* =========================================================
     MONEY PRODUCTS
     Reads JSON from HTML instead of Liquid inside JS asset.
  ========================================================= */

  const moneyData =
    document.getElementById(
      "pandit-money-products"
    );


  if (moneyData) {

    try {

      const moneyProducts =
        JSON.parse(
          moneyData.textContent
        );


      if (Array.isArray(moneyProducts) &&
          moneyProducts.length) {

        const dynamicProducts =
          moneyProducts.length > 3
            ? moneyProducts.slice(3)
            : moneyProducts;


        const img =
          document.getElementById(
            "dynamicProductImg"
          );

        const title =
          document.getElementById(
            "dynamicProductTitle"
          );

        const link =
          document.getElementById(
            "dynamicProductLink"
          );


        if (
          img &&
          title &&
          link &&
          dynamicProducts.length
        ) {

          let index =
            Math.floor(
              Math.random() *
              dynamicProducts.length
            );


          function changeProduct() {

            const product =
              dynamicProducts[index];

            if (!product) return;


            img.style.opacity = 0;


            setTimeout(() => {

              img.src =
                product.image || "";

              img.alt =
                product.title || "";

              title.textContent =
                product.title?.length > 20
                  ? product.title.substring(0, 20) + "..."
                  : product.title || "";

              link.href =
                product.url || "#";


              img.style.opacity = 1;

            }, 300);


            index =
              (index + 1) %
              dynamicProducts.length;

          }


          changeProduct();


          setInterval(
            changeProduct,
            5000
          );

        }

      }

    } catch (error) {

      console.error(
        "Money products JSON error:",
        error
      );

    }

  }

});